
import React, {useState} from 'react';
import ErrorMessage from '../../components/errorMessage.js'

/**
Because of an internal error we are not able to process your request. 
                    Rest assured, the error was logged and we will have our engineers investigating it!
*/

// Interface for error page data
interface ErrorPageData {
    result404?: boolean;
    result500?: boolean;
}

// Interface for component props
interface ErrorRoutePageProps {
    server: string;
    pageData: ErrorPageData;
}

export default function ErrorRoutePage({server, pageData}: ErrorRoutePageProps) {

	let [data, setData] = useState<ErrorPageData>(pageData);

    let errorMessage: string = 'Unexpected error happened!';

    if (data && data.result404) {
        errorMessage = '404: We could not find the page you were looking for.'
    }
    else if (data && data.result500) {
        errorMessage = '500: Because of an internal error we are not able to process your request. Rest assured, the error was logged and we will have our engineers investigating it!'
    }

    return (
        <ErrorMessage message={errorMessage} />
    )
}
